import {useEffect} from 'react';
import {Platform} from 'react-native';

/*
- hook to hide scroll bar when based on passed boolean value.
- if is not web platform it will retrun.
*/

export const useDisableBodyScroll = open => {
  useEffect(() => {
    // Hooks must run unconditionally; the platform gate lives inside the effect.
    if (Platform.OS !== 'web') {
      return;
    }
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [open]);
};
